export default "__VITE_ASSET__C51pPSk9__"